import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex flex-col items-center justify-center px-5 text-center">
      <p className="font-mono text-primary mb-4 uppercase tracking-widest">Error 404</p>
      <h1 className="font-display text-[22vw] md:text-[12rem] leading-none">404</h1>
      <p className="text-xl text-muted-foreground mt-4 mb-10">This page wandered off. Let's get you back.</p>
      <Link to="/" className="inline-flex items-center gap-2 bg-primary text-white px-8 py-4 font-semibold hover:bg-primary/90 active:scale-95 transition"><ArrowLeft className="w-4 h-4" /> Back to Home</Link>
    </div>
  );
}
